import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {LeadContactTypesActions} from '../store';
import {LeadContactTypesSelectors} from '../store/selectors';

@Injectable()
export class LeadContactTypesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadContactTypes().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadContactTypes() {
    return this.store.pipe(
      select(LeadContactTypesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(LeadContactTypesActions.LoadLeadContactTypes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
